import React from "react"
import styled from "styled-components"
import { connect } from "react-redux"
import { Scrollbars } from "react-custom-scrollbars"
import RouterView from "./router"
import Sidebar from "views/Layout/Sidebar"
import Header from "views/Layout/Header"
import Footer from "views/Layout/Footer"

const Container = styled.div`
		height: 100vh;
		overflow: hidden;
		position: relative;
	`,
	Layout = styled.div`
		height: 100%;
		background: #efefef;
		transition: 0.3s;
		position: relative;
		left: ${(props) => (props.show ? "240px" : "0")};
	`,
	Mask = styled.div`
		background: rgba(0, 0, 0, 0.5);
		position: absolute;
		top: 0;
		bottom: 0;
		right: 0;
		left: 0;
		z-index: 99;
	`,
	OuterWrap = styled.div`
		height: 100%;
		display: flex;
		flex-direction: column;
	`,
	InnerWrap = styled.div`
		flex: 1;
	`

function App(props) {
	return (
		<Container className="App">
			<Sidebar />
			<Layout show={props.sideShow}>
				<Header />
				<Scrollbars>
					<OuterWrap>
						<InnerWrap>
							<RouterView />
						</InnerWrap>
						<Footer />
					</OuterWrap>
				</Scrollbars>
				{props.sideShow && props.sideShow ? <Mask onClick={() => props.sidebarHandle()} /> : ""}
			</Layout>
		</Container>
	)
}

export default connect(
	(state) => ({ sideShow: state.control.sideShow }),
	(dispatch) => ({
		sidebarHandle: () => dispatch({ type: "SIDESHOW_HANDLE" }),
	})
)(App)
